import React, { useEffect, useState } from 'react'
import {
  Input,
  Row,
  Col,
  Card,
  Button,
  message,
  Upload,
  Tabs,
  Select,
  notification,
  Table,
  Modal
} from 'antd'
import axios from 'axios'
import Cookies from 'js-cookie'
import { get_v10_url } from '../utils/commonUtilities'
import {
  UploadOutlined,
  SettingOutlined,
  EditOutlined,
  CloseCircleOutlined
} from '@ant-design/icons'
import { useSelector } from 'react-redux'
import { Country, State, City } from 'country-state-city'
import GlobalLoader from '../Components/GlobalLoader'
import ViewPdfModal from '../Components/ViewPdfModal'

const HospitalDetails = props => {
  const [tabNo, setTabNo] = useState(1)
  const [editNo, setEditNo] = useState(0)
  const [getFlag, setGetFlag] = useState(false)
  const [data, setData] = useState({
    accountContactNumber: '',
    accountNumber: '',
    branchAddress: '',
    careType: '',
    city: '',
    dayCareBeds: '',
    icuBeds: '',
    ifscCode: '',
    inPatientBeds: '',
    locality: '',
    marketingTpaHead: '',
    medicalSuperintendent: '',
    multispeciality: false,
    panHolderName: '',
    panNumber: '',
    pinCode: '',
    ppnStatus: '',
    registrationNumber: '',
    rohiniID: '',
    state: '',
    registrationAuthority: '',
    address: '',
    cancelledCheque: '',
    hospitalRohini: '',
    regCertificated: '',
    tarrifList: '',
    phoneNumber: '',
    mobileNo: '',
    emailID: '',
  })
  const [postData, setPostData] = useState({})
  const [docUploadModal, setDocUploadModal] = useState(false)
  const [generalInfo, setGeneralInfo] = useState({
    cancelledCheque: '',
    hospitalRohini: '',
    regCertificated: '',
    tarrifList: '',
    panCard: '',
    gstCertificate: '',
  })
  const [chequeUpload, setChequeUpload] = useState(false)
  const [rohiniUpload, setRohiniUpload] = useState(false)
  const [regUpload, setRegUpload] = useState(false)
  const [tariffUpload, setTariffUpload] = useState(false)
  const [panUpload, setPanUpload] = useState(false)
  const [gstUpload, setGstUpload] = useState(false)
  const [documents, setDocuments] = useState([])
  const [docUpload, setDocUpload] = useState(false)
  const [addDoc, setAddDoc] = useState({
    docName: '',
    docURL: '',
  })
  const [otherDocuments, setOtherDocuments] = useState([])
  const [fileList, setFileList] = useState([])
  
  const country = Country.getCountryByCode('IN')
  const [statesList, setStatesList] = useState([])
  const [stateISO, setStateISO] = useState('')
  const [citiesList, setCitiesList] = useState([])

  const [loading, setLoading] = useState(false)
  const [pdfUrl, setPdfUrl] = useState('')

  const hospitalData = useSelector(state => state.authStore?.user)

  useEffect(() => {
    const state = State.getStatesOfCountry(country.isoCode)
    let stateArray = []
    if(state.length > 0) {
      state.map(item => {
        stateArray.push({
          label: item.name,
          value: item.name,
          isoCode: item.isoCode
        })
      })
    }
    setStatesList(stateArray)
  }, [])

  const handleSelectedState = (value, option) => {
    setPostData({
      ...postData,
      state: value,
      city: ''
    })
    setStateISO(option?.isoCode)
  }

  useEffect(() => {
    const city = City.getCitiesOfState('IN', stateISO)
    let cityArray = []
    if(stateISO === 'MP') {
      cityArray.push({
        label: 'Barwaha',
        value: 'Barwaha'
      })
    }
    if(city.length > 0) {
      city.map(item => {
        cityArray.push({
          label: item.name,
          value: item.name
        })
      })
    }
    setCitiesList(cityArray)
  }, [stateISO])

  useEffect(() => {
    props.setActiveSideKey('6')
    setLoading(true)
    const headers = {
      headers: { Authorization: `Bearer ${Cookies.get('token_medical_auth')}` }
    }
    axios
      .get(`${get_v10_url()}/professional/getHospitalInfo`, headers)
      .then(res => {
        setData({ ...data, ...res.data?.data })
        const hosDocs = []
        if(res.data?.data?.cancelledCheque) {
          hosDocs.push({srNo: 1, docName: "Cancelled Cheque" , docUrl: res.data?.data?.cancelledCheque})
        }
        if(res.data?.data?.hospitalRohini) {
          hosDocs.push({srNo: 2, docName: "Hospital ROHINI" , docUrl: res.data?.data?.hospitalRohini})
        }
        if(res.data?.data?.regCertificated) {
          hosDocs.push({srNo: 3, docName: "Registration Certificate" , docUrl: res.data?.data?.regCertificated})
        }
        if(res.data?.data?.tarrifList) {
          hosDocs.push({srNo: 4, docName: "TARIFF List" , docUrl: res.data?.data?.tarrifList})
        }
        if(res.data?.data?.panURL) {
          hosDocs.push({srNo: 5, docName: "PAN Card" , docUrl: res.data?.data?.panURL})
        }
        if(res.data?.data?.gstCertificate) {
          hosDocs.push({srNo: 6, docName: "GST Certificate" , docUrl: res.data?.data?.gstCertificate})
        }
        if(res.data?.data?.otherDocuments) {
          res.data?.data?.otherDocuments?.map((doc, idx) => {
            hosDocs.push({srNo: idx + 7, docName: doc.docName , docUrl: doc.docURL})
          })
        }
        setDocuments(hosDocs)
        // console.warn(res.data?.data)
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [getFlag])

  useEffect(() => {
    setPostData(data)
  }, [data])

  useEffect(() => {
    setEditNo(0)
  }, [tabNo])

  const handleCancel = () => {
    setEditNo(0)
    setPostData(data)
  }

  const uploadCancelledChequeProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadCancelledCheque`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange (info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status !== 'removed') {
        setChequeUpload(true)
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setGeneralInfo({...generalInfo, cancelledCheque: resBooking.docURL})
        message.success(`${info.file.name} file uploaded successfully`)
        setChequeUpload(false)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
        setChequeUpload(false)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, cancelledCheque: '' });
    },
    maxCount: 1,
  }

  const uploadHospitalRohini = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadHospitalRohini`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange (info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status !== 'removed') {
        setRohiniUpload(true)
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`)
        const resBooking = info.file.response.data
        setGeneralInfo({...generalInfo, hospitalRohini: resBooking.docURL})
        setRohiniUpload(false)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
        setRohiniUpload(false)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, hospitalRohini: '' });
    },
    maxCount: 1,
  }

  const uploadRegistrationCertificate = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadRegistrationCertificate`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange (info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status !== 'removed') {
        setRegUpload(true)
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`)
        const resBooking = info.file.response.data
        setGeneralInfo({...generalInfo, regCertificated: resBooking.docURL})
        setRegUpload(false)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
        setRegUpload(false)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, regCertificated: '' });
    },
    maxCount: 1,
  }

  const uploadTarriffList = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadTarriffList`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange (info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status !== 'removed') {
        setTariffUpload(true)
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`)
        const resBooking = info.file.response.data
        setGeneralInfo({...generalInfo, tarrifList: resBooking.docURL})
        setTariffUpload(false)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
        setTariffUpload(false)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, tarrifList: '' });
    },
    maxCount: 1,
  }

  const uploadPanCardProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadPanCard`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status !== 'removed') {
        setPanUpload(true)
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setGeneralInfo({ ...generalInfo, panCard: resBooking.docURL })
        message.success(`${info.file.name} file uploaded successfully`)
        setPanUpload(false)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
        setPanUpload(false)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, panCard: '' });
    },
    maxCount: 1,
  }

  const uploadGstCertificateProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadGstCertificate`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status !== 'removed') {
        setGstUpload(true)
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setGeneralInfo({ ...generalInfo, gstCertificate: resBooking.docURL })
        message.success(`${info.file.name} file uploaded successfully`)
        setGstUpload(false)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
      }
    },
    onRemove(file) {
      setGeneralInfo({ ...generalInfo, gstCertificate: '' });
      setGstUpload(false)
    },
    maxCount: 1,
  }

  const uploadOtherDocumentProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadHospitalDocument`,
    headers: {
      Authorization: `Bearer ${Cookies.get('token_medical_auth')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) <= 20
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size up to 20 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange(info) {
      // console.log(info);
      setFileList(info.fileList)
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList)
      }
      if (info.file.status !== 'removed') {
        setDocUpload(true)
        // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setAddDoc({ ...addDoc, docURL: resBooking.docURL })
        message.success(`${info.file.name} file uploaded successfully`)
        setDocUpload(false)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
        setDocUpload(false)
      }
    },
    onRemove(file) {
      setAddDoc({ ...addDoc, docURL: '' })
    },
    fileList: fileList,
    maxCount: 1,
  }

  const handleGeneralInfoSubmit = () => {
    if(postData?.state === '') {
      notification.error({
        message: 'Error',
        description: 'State cannot be empty'
      })
      return
    }
    if(postData?.city === '') {
      notification.error({
        message: 'Error',
        description: 'City cannot be empty'
      })
      return
    }
    if(postData?.pinCode === '') {
      notification.error({
        message: 'Error',
        description: 'PIN Code cannot be empty'
      })
      return
    }
    if(postData?.pinCode?.length < 6) {
      notification.error({
        message: 'Error',
        description: 'PIN Code cannot be less than 6 digits'
      })
      return
    }
    if(postData?.address === '') {
      notification.error({
        message: 'Error',
        description: 'Address cannot be empty'
      })
      return
    }
    if(postData?.medicalSuperintendent === '') {
      notification.error({
        message: 'Error',
        description: 'Medical Superintendent cannot be empty'
      })
      return
    }
    if(postData?.marketingTpaHead === '') {
      notification.error({
        message: 'Error',
        description: 'Marketing TPA/Head cannot be empty'
      })
      return
    }
    if(postData?.registrationNumber === '') {
      notification.error({
        message: 'Error',
        description: 'Registration number cannot be empty'
      })
      return
    }
    if(postData?.registrationAuthority === '') {
      notification.error({
        message: 'Error',
        description: 'Registration authority cannot be empty'
      })
      return
    }
    if(postData?.rohiniID === '') {
      notification.error({
        message: 'Error',
        description: 'Rohini code cannot be empty'
      })
      return
    }
    if(postData?.panNumber === '') {
      notification.error({
        message: 'Error',
        description: 'Hospital PAN number cannot be empty'
      })
      return
    }
    if(postData?.panHolderName === '') {
      notification.error({
        message: 'Error',
        description: 'PAN holder name cannot be empty'
      })
      return
    }

    handleSubmit()
  }

  const handleBasicInfoSubmit = () => {
    if(postData?.inPatientBeds === '' || postData?.inPatientBeds < 0) {
      notification.error({
        message: 'Error',
        description: 'No. of inpatient beds cannot be empty or negative'
      })
      return
    }
    if(postData?.dayCareBeds === '' || postData?.dayCareBeds < 0) {
      notification.error({
        message: 'Error',
        description: 'No. of day care beds cannot be empty or negative'
      })
      return
    }
    if(postData?.icuBeds === '' || postData?.icuBeds < 0) {
      notification.error({
        message: 'Error',
        description: 'No. of ICU beds cannot be empty or negative'
      })
      return
    }

    handleSubmit()
  }

  const handleAccountInfoSubmit = () => {
    if(postData?.accountNumber === '') {
      notification.error({
        message: 'Error',
        description: 'Account number cannot be empty'
      })
      return
    }
    if(postData?.ifscCode === '') {
      notification.error({
        message: 'Error',
        description: 'IFSC code cannot be empty'
      })
      return
    }
    if(postData?.branchAddress === '') {
      notification.error({
        message: 'Error',
        description: 'Branch address cannot be empty'
      })
      return
    }
    if(postData?.registrationAuthority === '') {
      notification.error({
        message: 'Error',
        description: 'Registration authority cannot be empty'
      })
      return
    }
    if(postData?.accountContactNumber === '') {
      notification.error({
        message: 'Error',
        description: 'Account contact number cannot be empty'
      })
      return
    }
    if(postData?.accountContactNumber !== '' && postData?.accountContactNumber.length !== 10) {
      notification.error({
        message: 'Error',
        description: 'Account contact number cannot be less or greater than 10 digits'
      })
      return
    }

    handleSubmit()
  }

  const handleSubmit = () => {
    // console.warn({postData})
    if(postData?.pinCode?.length < 6) {
      notification.error({
        message: 'Error',
        description: 'PIN Code cannot be less than 6 digits'
      })
      return
    }
    if(postData?.accountContactNumber !== '' && postData?.accountContactNumber?.length !== 10) {
      notification.error({
        message: 'Error',
        description: 'Contact number cannot be less or greater than 10 digits'
      })
      return
    }
    if(postData?.phoneNumber !== '' && postData?.phoneNumber?.length !== 10) {
      notification.error({
        message: 'Error',
        description: 'Alternate number cannot be less or greater than 10 digits'
      })
      return
    }
    const headers = {
      headers: { Authorization: `Bearer ${Cookies.get('token_medical_auth')}` }
    }
    const body = {...postData, ...generalInfo, othersDocuments: otherDocuments}
    body['hospitalPAN'] = postData.panNumber
    body['rohiniCode'] = postData.rohiniID
    body['tpaHead'] = postData.marketingTpaHead
    body['hospitalRegistrationNo'] = postData.registrationNumber
    body['contactNo'] = postData.accountContactNumber
    body['accountNo'] = postData.accountNumber
    body['dayCarebeds'] = postData.dayCareBeds
    body['impatientBeds'] = postData.inPatientBeds
    // delete body.panNumber
    delete body.rohiniID
    delete body.marketingTpaHead
    delete body.registrationNumber
    delete body.accountContactNumber
    delete body.accountNumber
    delete body.dayCareBeds
    delete body.inPatientBeds
    setLoading(true)
    axios
      .post(`${get_v10_url()}/professional/updateHospitalInfo`, body, headers)
      .then(res => {
        if (res.data?.success) {
          setGetFlag(f => !f)
          setEditNo(0)
          setDocUploadModal(false)
          setFileList([])
          setAddDoc({docName:'',docURL:''})
          setOtherDocuments([])
          notification.success({
            message: 'Success',
            description: 'Hospital details updated successfully'
          })
          // window.location.reload()
        } else {
          notification.error({
            message: 'Error',
            description: 'Could not update hospital details'
          })
        }
      })
      .catch(err => {
        console.error(err)
        const errMsg = err.response?.data?.message
        notification.error({
          message: 'Error',
          description: errMsg || 'Please try again'
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleAddNewDoc = () => {
    if (!addDoc.docName || !addDoc.docURL) {
      notification.error({
        message: "Error",
        description: "Please enter document name and upload the document before adding."
      })
      return
    }
    otherDocuments.push({
      docName: addDoc.docName,
      docURL: addDoc.docURL,
    })
    setAddDoc({ docName: '', docURL: '' })
    setFileList([])
  }

  const handleDeleteDoc = (name, url) => {
    const updtaedDoc = [...otherDocuments].filter(doc => doc.docURL !== url)
    setOtherDocuments(updtaedDoc)
  }

  const documentsColumns = [
    {
      title: 'S No.',
      dataIndex: 'srNo',
      key: 'srNo',
      width: '10%',
      render: (text) => <span>{text}</span>
    },
    {
      title: 'Uploaded Document',
      dataIndex: 'docName',
      key: 'docName',
      width: '20%',
      render: (text) => <span>{text}</span>
    },
    // {
    //   title: 'Uploaded On',
    //   dataIndex: 'uploadedOn',
    //   key: 'uploadedOn',
    //   width: '20%',
    //   render: (text, record) => <span>{record.uploadedOn}</span>
    // },
    // {
    //   title: 'Type',
    //   dataIndex: 'type',
    //   key: 'type',
    //   width: '10%',
    //   render: (text, record) => <span>{record.type}</span>
    // },
    // {
    //   title: 'View',
    //   dataIndex: 'view',
    //   key: 'view',
    //   width: '20%',
    //   render: (text, record) => (
    //     <a
    //       href
    //       onClick={e => {
    //         e.preventDefault()
    //         window.open(record.view)
    //       }}
    //     >
    //       View
    //     </a>
    //   )
    // },
    {
      title: 'View',
      dataIndex: 'docUrl',
      key: 'docUrl',
      width: '20%',
      render: (text) => text && <a onClick={()=>{setPdfUrl(text)}}>View</a>
    }
  ]

  return (
    <>
    {loading && <GlobalLoader/>}
      <div
        className='settings-page hospital-details-card'
        style={{ height: '100%' }}
      >
        <Card
          title={
            <div>
              <SettingOutlined style={{ marginRight: '10px' }} /> <span style={{fontSize:'1.2rem', fontWeight:'500'}}>Settings</span>
            </div>
          }
          headStyle={{
            marginLeft: '180px',
            height: '64px',
            position: 'relative',
            padding: '0px'
          }}
          bodyStyle={{ padding: '0px', height: 'calc(100% - 64px)' }}
          style={{ height: '100%' }}
        >
          <div style={{ height: '100%', padding: '20px' }}>
            <Tabs>
              <Tabs.TabPane
                tab={
                  <span onClick={() => setTabNo(1)}>General Information</span>
                }
                key={1}
              >
                <div className='settings-content'>
                  {editNo !== tabNo && (
                    <div className='edit-btn' onClick={() => setEditNo(tabNo)}>
                      <EditOutlined />
                    </div>
                  )}
                  <Row gutter={24}>
                    <Col span={6}>
                      <label>Type of Hospital{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Select
                          options={[
                            {
                              label: 'Single Speciality',
                              value: 'Single Speciality'
                            },
                            {
                              label: 'Multi Speciality',
                              value: 'Multi Speciality'
                            }
                          ]}
                          value={
                            postData?.multispeciality
                              ? 'Multi Speciality'
                              : 'Single Speciality'
                          }
                          onChange={e => {
                            setPostData({
                              ...postData,
                              multispeciality: e === 'Multi Speciality' ? true : false,
                              hospitalType: e === 'Multi Speciality' ? 'Multi Speciality' : 'Single Speciality'
                            })
                          }}
                          getPopupContainer={trigger => trigger.parentElement}
                        ></Select>
                      ) : (
                        <div className='value'>
                          {data.multispeciality
                            ? 'Multi Speciality'
                            : 'Single Speciality'}
                        </div>
                      )}
                    </Col>
                    <Col span={6}>
                      <label>Type of Care{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Select
                          options={[
                            {
                              label: 'Primary Care',
                              value: 'Primary Care'
                            },
                            {
                              label: 'Secondary Care',
                              value: 'Secondary Care'
                            },
                            {
                              label: 'Tertiary Care',
                              value: 'Tertiary Care'
                            }
                          ]}
                          onChange={e =>
                            setPostData({ ...postData, careType: e })
                          }
                          value={postData?.careType}
                          getPopupContainer={trigger => trigger.parentElement}
                        ></Select>
                      ) : (
                        <div className='value'>{data.careType}</div>
                      )}
                    </Col>
                    <Col span={6}>
                      <label>PPN Status{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Select
                          options={[
                            {
                              label: 'PPN',
                              value: 'PPN'
                            },
                            {
                              label: 'Non-PPN',
                              value: 'Non-PPN'
                            }
                          ]}
                          onChange={e =>
                            setPostData({ ...postData, ppnStatus: e })
                          }
                          value={postData?.ppnStatus}
                          getPopupContainer={trigger => trigger.parentElement}
                        />
                      ) : (
                        <div className='value'>{data.ppnStatus}</div>
                      )}
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={8}>
                      <label>Hospital Name</label>
                      <div className='value'>
                        {hospitalData?.name}
                      </div>
                    </Col>
                    <Col span={4}>
                      <label>State{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Select
                          type='select'
                          value={postData?.state}
                          placeholder='Select Sate'
                          isMulti={false}
                          onChange={handleSelectedState}
                          style={{width:'100%'}}
                          showSearch
                          optionFilterProp='children'
                          filterOption={(input, option) => 
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                          filterSort={(opA, opB) =>
                            (opA?.label ?? '').toLowerCase().localeCompare((opB?.label ?? '').toLowerCase()) 
                          }
                          getPopupContainer={trigger => trigger.parentElement}
                        >
                          {statesList.map(state => (
                            <Select.Option value={state.value} isoCode={state.isoCode}>
                              {state.label}
                            </Select.Option>
                          ))}
                        </Select>
                      ) : (
                        <div className='value'>{data.state}</div>
                      )}
                    </Col>
                    <Col span={4}>
                      <label>City{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Select
                          type='select'
                          options={citiesList}
                          value={postData?.city || undefined}
                          placeholder='Select City'
                          onChange={e => setPostData({...postData, city: e})}
                          isMulti={false}
                          style={{width:'100%'}}
                          showSearch
                          optionFilterProp='children'
                          filterOption={(input, option) => 
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                          }
                          filterSort={(opA, opB) => 
                            (opA?.label ?? '').toLowerCase().localeCompare((opB?.label ?? '').toLowerCase())
                          }
                          getPopupContainer={trigger => trigger.parentElement}
                        />
                      ) : (
                        <div className='value'>{data.city}</div>
                      )}
                    </Col>
                    <Col span={4}>
                      <label>City PIN Code{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Input
                          value={postData?.pinCode}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              pinCode: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter PIN Code'
                        />
                      ) : (
                        <div className='value'>{data.pinCode}</div>
                      )}
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <label>Address{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Input
                          value={postData?.address}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              address: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter Address'
                        />
                      ) : (
                        <div className='value'>{postData?.address}</div>
                      )}
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={4}>
                      <label>Alternate No.</label>
                      {editNo === tabNo ? (
                        <Input
                          value={postData?.alternateNumber}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              alternateNumber: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter Alternate No.'
                        />
                      ) : (
                        <div className='value'>{postData?.alternateNumber ? postData?.alternateNumber : 'N/A'}</div>
                      )}
                    </Col>
                    <Col span={4}>
                      <label>Mobile No.</label>
                      <div className='value'>{hospitalData?.mobileNumber}</div>
                    </Col>
                    <Col span={4}>
                      <label>Email ID</label>
                      <div className='value'>{hospitalData?.email}</div>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={6}>
                      <label>Medical Superintendent{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Input
                          value={postData?.medicalSuperintendent}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              medicalSuperintendent: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter Medical Superintendent'
                        />
                      ) : (
                        <div className='value'>
                          {data.medicalSuperintendent}
                        </div>
                      )}
                    </Col>
                    <Col span={6}>
                      <label>Marketing TPA/Head{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Input
                          value={postData?.marketingTpaHead}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              marketingTpaHead: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter Marketing TPA/Head'
                        />
                      ) : (
                        <div className='value'>{data.marketingTpaHead}</div>
                      )}
                    </Col>
                    <Col span={6}>
                      <label>Hospital Registration No.{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Input
                          value={postData?.registrationNumber}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              registrationNumber: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter Hospital Registration No.'
                        />
                      ) : (
                        <div className='value'>{data.registrationNumber}</div>
                      )}
                    </Col>
                    <Col span={6}>
                      <label>Registration Authority{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Input
                          value={postData?.registrationAuthority}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              registrationAuthority: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter Registration Authority'
                        />
                      ) : (
                        <div className='value'>
                          {data.registrationAuthority}
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={6}>
                      <label>ROHINI Code{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Input
                          value={postData?.rohiniID}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              rohiniID: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter ROHINI Code'
                        />
                      ) : (
                        <div className='value'>{data.rohiniID}</div>
                      )}
                    </Col>
                    <Col span={6}>
                      <label>PAN Number of Hospital{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Input
                          value={postData?.panNumber}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              panNumber: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter PAN Number of Hospital'
                        />
                      ) : (
                        <div className='value'>{data.panNumber}</div>
                      )}
                    </Col>
                    <Col span={6}>
                      <label>Account Holder Name{editNo===tabNo && <>*</>}</label>
                      {editNo === tabNo ? (
                        <Input
                          value={postData?.panHolderName}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              panHolderName: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter Account Holder Name'
                        />
                      ) : (
                        <div className='value'>{data.panHolderName}</div>
                      )}
                    </Col>
                  </Row>
                  {editNo === tabNo && (
                    <Row
                      gutter={24}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Col span={8}>
                        <Button className='btn-cancel' onClick={handleCancel}>
                          Cancel
                        </Button>
                      </Col>
                      <Col span={8}>
                        <Button className='btn-submit' onClick={()=>handleGeneralInfoSubmit()}>
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  )}
                </div>
              </Tabs.TabPane>

              <Tabs.TabPane
                tab={
                  <span onClick={() => setTabNo(2)}>
                    Basic & Account Information
                  </span>
                }
                key={2}
              >
                <Card title='Basic Information' className='bank-details'>
                  {editNo !== 2 && (
                    <div className='edit-btn' onClick={() => setEditNo(2)}>
                      <EditOutlined />
                    </div>
                  )}
                  <Row gutter={24}>
                    <Col span={8}>
                      <label>No. of Hospital Inpatient Beds{editNo===2 && <>*</>}</label>
                      {editNo === 2 ? (
                        <Input
                          value={postData?.inPatientBeds}
                          type='number'
                          onChange={e =>
                            setPostData({
                              ...postData,
                              inPatientBeds: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter No. of Hospital Inpatient Beds'
                        />
                      ) : (
                        <div className='value'>{data.inPatientBeds}</div>
                      )}
                    </Col>
                    <Col span={8}>
                      <label>No. of Day Care beds{editNo===2 && <>*</>}</label>
                      {editNo === 2 ? (
                        <Input
                          value={postData?.dayCareBeds}
                          type='number'
                          onChange={e =>
                            setPostData({
                              ...postData,
                              dayCareBeds: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter No. of Day Care beds'
                        />
                      ) : (
                        <div className='value'>{data.dayCareBeds}</div>
                      )}
                    </Col>
                    <Col span={8}>
                      <label>No. of ICU Beds{editNo===2 && <>*</>}</label>
                      {editNo === 2 ? (
                        <Input
                          value={postData?.icuBeds}
                          type='number'
                          onChange={e =>
                            setPostData({
                              ...postData,
                              icuBeds: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter No. of ICU Beds'
                        />
                      ) : (
                        <div className='value'>{data.icuBeds}</div>
                      )}
                    </Col>
                  </Row>
                  {editNo === 2 && (
                    <Row
                      gutter={24}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Col span={8}>
                        <Button className='btn-cancel' onClick={handleCancel}>
                          Cancel
                        </Button>
                      </Col>
                      <Col span={8}>
                        <Button className='btn-submit' onClick={()=>handleBasicInfoSubmit()}>
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Card>
                <Card
                  title='Account Information'
                  className='bank-details'
                  style={{ marginTop: '20px' }}
                >
                  {editNo !== 3 && (
                    <div className='edit-btn' onClick={() => setEditNo(3)}>
                      <EditOutlined />
                    </div>
                  )}
                  <Row gutter={24}>
                    <Col span={6}>
                      <label>Bank Account Number{editNo===3 && <>*</>}</label>
                      {editNo === 3 ? (
                        <Input
                          value={postData?.accountNumber}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              accountNumber: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter Bank Account Number'
                        />
                      ) : (
                        <div className='value'>{data.accountNumber}</div>
                      )}
                    </Col>
                    <Col span={6}>
                      <label>IFSC Code{editNo===3 && <>*</>}</label>
                      {editNo === 3 ? (
                        <Input
                          value={postData?.ifscCode}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              ifscCode: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter IFSC Code'
                        />
                      ) : (
                        <div className='value'>{data.ifscCode}</div>
                      )}
                    </Col>
                    <Col span={6}>
                      <label>Branch Address{editNo===3 && <>*</>}</label>
                      {editNo === 3 ? (
                        <Input
                          value={postData?.branchAddress}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              branchAddress: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter Branch Address'
                        />
                      ) : (
                        <div className='value'>{data.branchAddress}</div>
                      )}
                    </Col>
                    <Col span={6}>
                      <label>Registration Authority{editNo===3 && <>*</>}</label>
                      {editNo === 3 ? (
                        <Input
                          value={postData?.registrationAuthority}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              registrationAuthority: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter Registration Authority'
                        />
                      ) : (
                        <div className='value'>
                          {data.registrationAuthority}
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={6}>
                      <label>Account Department Contact Number{editNo===3 && <>*</>}</label>
                      {editNo === 3 ? (
                        <Input
                          value={postData?.accountContactNumber}
                          onChange={e =>
                            setPostData({
                              ...postData,
                              accountContactNumber: e.target.value
                            })
                          }
                          className='form-input'
                          placeholder='Enter Account Department Contact Number'
                        />
                      ) : (
                        <div className='value'>{data.accountContactNumber}</div>
                      )}
                    </Col>
                  </Row>
                  {editNo === 3 && (
                    <Row
                      gutter={24}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Col span={8}>
                        <Button className='btn-cancel' onClick={handleCancel}>
                          Cancel
                        </Button>
                      </Col>
                      <Col span={8}>
                        <Button className='btn-submit' onClick={() => handleAccountInfoSubmit()}>
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Card>
              </Tabs.TabPane>

              <Tabs.TabPane
                tab={<span onClick={() => setTabNo(4)}>Documents</span>}
                key={4}
              >
                <Row gutter={24}>
                  <Col span={20}></Col>
                  <Col span={4}>
                    <Button className='btn-submit' style={{ width: '100%' }} onClick={()=>setDocUploadModal(true)}>
                      <UploadOutlined style={{ marginRight: '10px' }} />
                      Upload Docs
                    </Button>
                  </Col>
                </Row>
                <Card title={<span>Documents</span>} className='documents-card'>
                  <h1>Uploaded Documents</h1>
                  <Table 
                    dataSource={documents}
                    columns={documentsColumns}
                    pagination={{
                      pageSize: documents.length
                    }}
                  />
                </Card>
              </Tabs.TabPane>
            </Tabs>
          </div>
        </Card>
      </div>
      {pdfUrl && <ViewPdfModal openPDFModal={pdfUrl} pdfUrl={pdfUrl} setOpenPDFModal={setPdfUrl}/>}
      {docUploadModal && <Modal
        width={'60%'}
        open={docUploadModal}
        onOk={()=>{setDocUploadModal(false); setFileList([]); setAddDoc({docName:'',docURL:''}); setOtherDocuments([])}}
        onCancel={()=>{setDocUploadModal(false); setFileList([]); setAddDoc({docName:'',docURL:''}); setOtherDocuments([])}}
        className='hospital-doc-upload-modal'
        title="Upload Hospital Documents"
      >
        <div className='hospital-doc-modal-container'>
        <Row gutter={24} style={{marginBottom:'1.5rem'}}>
            <Col span={12}>
              <Upload
                {...uploadCancelledChequeProps}
                placeholder='Upload Cancelled Cheque'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />} className='upload-hospital-doc-btn'>
                  Upload Cancelled Cheque
                </Button>
              </Upload>
            </Col>
            <Col span={12}>
              <Upload
                {...uploadHospitalRohini}
                placeholder='Upload Hospital ROHINI'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />} className='upload-hospital-doc-btn'>
                  Upload Hospital ROHINI
                </Button>
              </Upload>
            </Col>
          </Row>
          <Row gutter={24} style={{marginBottom:'1.5rem'}}>
            <Col span={12}>
              <Upload
                {...uploadRegistrationCertificate}
                placeholder='Upload Registration Certificate'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />} className='upload-hospital-doc-btn'>
                  Upload Registration Certificate
                </Button>
              </Upload>
            </Col>
            <Col span={12}>
              <Upload
                {...uploadTarriffList}
                placeholder='Upload Tariff List'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />} className='upload-hospital-doc-btn'>
                  Upload TARIFF List
                </Button>
              </Upload>
            </Col>
          </Row>
          <Row gutter={24} style={{marginBottom:'1.5rem'}}>
            <Col span={12}>
              <Upload
                {...uploadPanCardProps}
                placeholder='Upload Registration Certificate'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />} className='upload-hospital-doc-btn'>
                  Upload PAN Card
                </Button>
              </Upload>
            </Col>
            <Col span={12}>
              <Upload
                {...uploadGstCertificateProps}
                placeholder='Upload Tariff List'
                style={{ width: '100%' }}
              >
                <Button icon={<UploadOutlined />} className='upload-hospital-doc-btn'>
                  Upload GST Certificate
                </Button>
              </Upload>
            </Col>
          </Row>
          <Row gutter={24} style={{marginBottom: '24px'}}>
            <Col span={12}>
                <Input 
                  value={addDoc.docName} 
                  onChange={e => setAddDoc({...addDoc, docName: e.target.value})} 
                  placeholder="Enter document name"
                  style={{marginTop:'0', height: '50px', border: '1px solid #01D25A', borderRadius:'8px'}}
                />
            </Col>
            <Col span={6}>
                <Upload {...uploadOtherDocumentProps}>
                  <Button icon={<UploadOutlined />} className='upload-hospital-doc-btn'>
                    Upload Document
                  </Button>
                </Upload>
            </Col>
            <Col span={6}>
                <Button className="docu-upload-submit-btn" style={{fontSize: '1rem', height:'50px'}} onClick={() => handleAddNewDoc()}>Add</Button>
            </Col>
          </Row>
          {otherDocuments.length > 0 && <Row gutter={24}>
            <Col span={24}>
                <div style={{display:'flex', alignItems: 'center', gap:'1rem', flexWrap:'wrap'}}>
                    {otherDocuments.map(doc => (
                        <div style={{display:'flex', alignItems: 'center', gap: '3rem', border:'1px solid #666666', borderRadius:'8px', padding:'0.5rem 0.75rem'}}>
                            <p style={{width: 'max-content', margin: '0'}}>{doc.docName}</p>
                            <CloseCircleOutlined style={{cursor: 'pointer', color:'#FE2222', fontSize:'18px'}} onClick={()=>handleDeleteDoc(doc.docName, doc.docURL)} />
                        </div>
                    ))}
                </div>
            </Col>
          </Row>}
          <Row gutter={24} style={{marginTop: '48px'}}>
            <Col span={18}/>
            <Col span={6}>
              <Button className='docu-upload-submit-btn' onClick={() => {
                if(!docUpload && !regUpload && !panUpload && !chequeUpload && !rohiniUpload && !tariffUpload && !gstUpload) {
                  handleSubmit()
                } else {
                  notification.warn({
                    message: "Please Wait",
                    description: "Some documents are still being uploaded. Please wait."
                  })
                }
              }}>
                Submit
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>}
    </>
  )
}

export default HospitalDetails
